import { Action } from '@ngrx/store';
import { PersistedSalesPlannerSettings } from './local-settings.util';

export const UPDATE_LOCAL_SETTINGS_IN_STATE = '[CRM] Update Local Settings In State';
export class UpdateLocalSettingsInState implements Action {
  readonly feature = 'crm';
  readonly type = UPDATE_LOCAL_SETTINGS_IN_STATE;
  readonly triggerStorageSync = false;
  constructor(public payload: any) {}
}

export const RESET_STATE = '[CRM] Reset Local Settings State';
export class ResetLocalSettingsState implements Action {
  readonly feature = 'crm';
  readonly type = RESET_STATE;
  readonly triggerStorageSync = false;
  constructor(public payload: any) {}
}

export const GET_SALES_PLANNER_USER_SETTINGS_FROM_SERVER = '[CRM] Get Sales Planner User Settings From Server';
export class GetSalesPlannerUserSettingsFromServer implements Action {
  readonly feature = 'crm';
  readonly type = GET_SALES_PLANNER_USER_SETTINGS_FROM_SERVER;
  readonly triggerStorageSync = false;
  constructor(public payload: { userId: string | number }) {}
}

export const GET_SALES_PLANNER_USER_SETTINGS_FROM_SERVER_SUCCESS =
  '[CRM] Get Sales Planner User Settings From Server Success';
export class GetSalesPlannerUserSettingsFromServerSuccess implements Action {
  readonly feature = 'crm';
  readonly type = GET_SALES_PLANNER_USER_SETTINGS_FROM_SERVER_SUCCESS;
  readonly triggerStorageSync = false;
  constructor(
    public payload: { recordExists: boolean; settings: Partial<PersistedSalesPlannerSettings> }
  ) {}
}

export const SAVE_SALES_PLANNER_USER_SETTINGS_TO_SERVER = '[CRM] Save Sales Planner User Settings To Server';
export class SaveSalesPlannerUserSettingsToServer implements Action {
  readonly feature = 'crm';
  readonly type = SAVE_SALES_PLANNER_USER_SETTINGS_TO_SERVER;
  readonly triggerStorageSync = false;
  constructor(public payload: PersistedSalesPlannerSettings) {}
}

export const SAVE_SALES_PLANNER_USER_SETTINGS_TO_SERVER_SUCCESS =
  '[CRM] Save Sales Planner User Settings To Server Success';
export class SaveSalesPlannerUserSettingsToServerSuccess implements Action {
  readonly feature = 'crm';
  readonly type = SAVE_SALES_PLANNER_USER_SETTINGS_TO_SERVER_SUCCESS;
  readonly triggerStorageSync = false;
  constructor(public payload: PersistedSalesPlannerSettings) {}
}

export const SAVE_SALES_PLANNER_USER_SETTINGS_TO_SERVER_FAILURE =
  '[CRM] Save Sales Planner User Settings To Server Failure';
export class SaveSalesPlannerUserSettingsToServerFailure implements Action {
  readonly feature = 'crm';
  readonly type = SAVE_SALES_PLANNER_USER_SETTINGS_TO_SERVER_FAILURE;
  readonly triggerStorageSync = false;
  constructor(public payload: { error: any; settings: PersistedSalesPlannerSettings }) {}
}

export type LocalSettingsAction =
  | UpdateLocalSettingsInState
  | ResetLocalSettingsState
  | GetSalesPlannerUserSettingsFromServer
  | GetSalesPlannerUserSettingsFromServerSuccess
  | SaveSalesPlannerUserSettingsToServer
  | SaveSalesPlannerUserSettingsToServerSuccess
  | SaveSalesPlannerUserSettingsToServerFailure;
